import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { permissionError } from "../../../util/Alert";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { DangerRight } from "../../api/toastServices";
import { ExInput } from "../../extras/Input";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import Button from "../../extras/Button";
import {
  activeBreak,
  getSalonSchedule,
  updateSalonTime,
} from "../../../redux/slice/salonSlice";
import ToggleSwitch from "../../extras/ToggleSwitch";
import { Box, Modal } from "@mui/material";

const ScheduleDialogue = () => {
  const { dialogueData, salonId } = useSelector((state) => state.dialogue);
  const { salonSchedule } = useSelector((state) => state.salon);
  const findIndex = salonSchedule?.findIndex(
    (value) => value?._id === dialogueData?.data?._id
  );

  const hasPermission = useSelector((state) => state.auth.admin.flag);
  const dispatch = useDispatch();
  const [openTime, setOpenTime] = useState("");
  const [closeTime, setCloseTime] = useState("");
  const [breakTime, setBreakTime] = useState("");
  const [endBreakTime, setEndBreakTime] = useState("");
  const [error, setError] = useState({
    openTime: "",
    closeTime: "",
  });

  let addTax;

  useEffect(() => {
    if (dialogueData) {
      setOpenTime(
        moment(dialogueData?.data?.openTime, "hh:mm A").format("hh:mm A")
      );
      setCloseTime(
        moment(dialogueData?.data?.closedTime, "hh:mm A").format("hh:mm A")
      );
      setBreakTime(
        moment(dialogueData?.data?.breakStartTime, "hh:mm A").format("hh:mm A")
      );
      setEndBreakTime(
        moment(dialogueData?.data?.breakEndTime, "hh:mm A").format("hh:mm A")
      );
      setOpenTime(dialogueData?.data?.openTime);
    }
  }, [dialogueData]);

  const handleSubmit = async (e) => {
    if (dialogueData.salonId == "6617c5ded03f8d115d62afe5")
      return permissionError();
    if (!hasPermission) return permissionError();
    // e.preventDefault();
    if (!openTime || !closeTime) {
      let error = {};
      if (!openTime) error.openTime = "Open time is required";
      if (!closeTime) error.closeTime = "Close time is required";
      return setError({ ...error });
    } else {
      let response;
      if (dialogueData) {
        if (salonSchedule[findIndex]?.isBreak === true) {
          addTax = {
            openTime: tConvert(openTime),
            closedTime: tConvert(closeTime),
            breakStartTime: tConvert(breakTime),
            breakEndTime: tConvert(endBreakTime),
          };
        } else {
          addTax = {
            openTime: tConvert(openTime),
            closedTime: tConvert(closeTime),
          };
        }
        const payload = {
          data: addTax,
          id: dialogueData?.salonId,
          day: dialogueData?.data?.day,
        };
        response = await dispatch(updateSalonTime(payload)).unwrap();
      }
      response.status ? dispatch(closeDialog()) : DangerRight(response.message);
    }
    dispatch(closeDialog());
  };

  function handleOpenTime(v) {
    console.log("v-->", v.target.value);
    
    setOpenTime(
    v.target.value
    );
  }

  function handleCloseTime(v) {
    console.log("v-->", v.target.value);
   
    setCloseTime(
      v.target.value
    );
  }

  function handleBreakTime(v) {
    console.log("v-->", v.target.value);

    setBreakTime(
     v.target.value
    );
  }

  function handleEndBreak(v) {
    console.log("v-->", v.target.value);
    setEndBreakTime(
     v.target.value
    );
  }

  useEffect(() => {
    const timePicker = document.querySelector(".rc-time-picker");
    if (timePicker) {
      timePicker.classList.remove("rc-time-picker");
    }
  }, []);

  return (
    <Modal
      open={true}
      onClose={closeDialog}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="model-style">
        {/* <div className="row justify-content-between align-items-center formHead">
                <div className="col-8">
                  <h2 className="text-theme m0">Salon time dialog</h2>
                </div>
                <div className="col-4">
                  <div
                    className="closeButton"
                    onClick={() => {
                      dispatch(closeDialog());
                    }}
                  >
                    <i className="ri-close-line"></i>
                  </div>
                </div>
              </div> */}
        <div className="model-header">
          <p className="m-0">Salon time</p>
        </div>
        <div className="model-body">
          <form  id="expertForm">
            <div className="row align-items-start formBody">
              <div className="col-12 col-md-6">
                <div className="inputData text  flex-row justify-content-start text-start">
                  <label className="col-12 m-0">Open time</label>
                  {/* <TimePicker
                            onChange={(e) => handleOpenTime(e)}
                            showSecond={false}
                            allowEmpty
                            use12Hours
                            defaultValue={
                              dialogueData
                                ? moment(
                                    dialogueData?.data?.openTime,
                                    "hh:mm a"
                                  )
                                : null
                            }
                          /> */}
                  <input
                    type="time"
                    className="form-control"
                    name="openTime"
                    value={
                      dialogueData
                        ? moment(dialogueData?.data?.openTime, "hh:mm A").format("HH:mm")
                        : null
                    }
                    // min={moment(dialogueData?.data?.closedTime, "hh:mm A").format("HH:mm") || ""}
                    onChange={(e) => handleOpenTime(e)}
                  />
                  {error && error?.openTime && (
                    <p className="errorMessage text-start">
                      {error && error?.openTime}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-12 col-md-6 inputData">
                <label className="col-12 m-0">Close time</label>
                {/* <TimePicker
                  onChange={(e) => handleCloseTime(e)}
                  showSecond={false}
                  allowEmpty
                  use12Hours
                  defaultValue={
                    dialogueData
                      ? moment(dialogueData?.data?.closedTime, "hh:mm a")
                      : null
                  }
                /> */}
                <input
                    type="time"
                    className="form-control"
                    name="closedTime"
                    value={
                      dialogueData
                        ? moment(dialogueData?.data?.closedTime, "hh:mm A").format("HH:mm")
                        : null
                    }
                    onChange={(e) => handleCloseTime(e)}
                  />
                {error && error?.closeTime && (
                  <p className="errorMessage text-start">
                    {error && error?.closeTime}
                  </p>
                )}
              </div>

              {salonSchedule[findIndex]?.isBreak === true ? (
                <div className="col-12 col-md-6 inputData">
                  <label className="col-12 m-0">Break start time</label>
                  {/* <TimePicker
                    onChange={(e) => handleBreakTime(e)}
                    showSecond={false}
                    allowEmpty
                    use12Hours
                    defaultValue={
                      salonSchedule[findIndex]?.breakStartTime
                        ? moment(
                            salonSchedule[findIndex]?.breakStartTime,
                            "hh:mm a"
                          )
                        : null
                    }
                  /> */}
                  <input
                    type="time"
                    className="form-control"
                    name="breakStartTime"
                    value={
                      salonSchedule[findIndex]?.breakStartTime
                        ? moment(
                            salonSchedule[findIndex]?.breakStartTime,
                            "hh:mm A").format("HH:mm")
                        : null
                    }
                    onChange={(e) => handleBreakTime(e)}
                  />
                </div>
              ) : (
                ""
              )}
              {salonSchedule[findIndex]?.isBreak === true ? (
                <div className="col-12 col-md-6 inputData">
                  <label className="col-12 m-0">Break End Time</label>
                  {/* <TimePicker
                    onChange={(e) => handleEndBreak(e)}
                    showSecond={false}
                    allowEmpty
                    use12Hours
                    defaultValue={
                      salonSchedule[findIndex]?.breakEndTime
                        ? moment(
                            salonSchedule[findIndex]?.breakEndTime,
                            "hh:mm a"
                          )
                        : null
                    }
                  /> */}

                  <input
                    type="time"
                    className="form-control"
                    name="breakEndTime"
                    value={
                      salonSchedule[findIndex]?.breakEndTime
                        ? moment(
                            salonSchedule[findIndex]?.breakEndTime,
                            "hh:mm A").format("HH:mm")
                        : null
                    }
                    onChange={(e) => handleEndBreak(e)}
                  />
                </div>
              ) : (
                ""
              )}

              <div className="col-12 col-md-6 inputData">
                <label className="col-12 m-0">Enable or Disable break</label>
                <ToggleSwitch
                  value={
                    // dialogueData?.data?.isBreak ||
                    salonSchedule[findIndex]?.isBreak
                  }
                  onClick={() => {
                    if (!hasPermission) return permissionError();

                    const payload = {
                      id: dialogueData?.salonId,
                      day: dialogueData?.data?.day,
                    };
                    dispatch(activeBreak(payload));
                    dispatch(getSalonSchedule(dialogueData?.salonId));
                  }}
                />
              </div>

              <p className="extention-show">
                Note :- If you enable a break, please select both break start
                time and break end time. If you do not select these times, some
                misfunction found in app.
              </p>
            </div>
          </form>
        </div>
        <div className="model-footer">
         <div className="m-3 d-flex justify-content-end gap-2">
              <Button
                className={`close-model-btn`}
                text={`Cancel`}
                onClick={() => dispatch(closeDialog())}
              />
              <Button
                type={`submit`}
                text={`Submit`}
                onClick={()=>{handleSubmit()}}
              />
            </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ScheduleDialogue;

function tConvert(time) {
  // Check correct time format and split into components
  const formatTime = time
    .toString()
    .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:([0-5]\d))?$/) || [time];

  if (formatTime.length > 1) {
    const timeParts = formatTime.slice(1);
    const period = +timeParts[0] < 12 ? " AM" : " PM";
    const hours = +timeParts[0] % 12 || 12; // Adjust hours
    const minutes = timeParts[2].padStart(2, "0");

    return hours + ":" + minutes + period;
  }

  return time;
}
